import React from 'react';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import SearchListComponent from '../../components/search/SearchList/SearchList';

const SearchList: React.FC = () => {
  return (
    <PageContainer title="Searches">
      <SearchListComponent />
    </PageContainer>
  );
};

export default SearchList; 